export default __webpack_public_path__ + "static/media/menüzeichen_balken.5c69f95a.png";